
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { HomeComponent } from './home.component';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { AuthGuard } from '../guards/auth.guard';
import { NotificationViewComponent } from '../notification/notification-view/notification-view.component';
import { NgModule } from '@angular/core';


const routes: Routes = [
      //  { path: '' , component: HomeComponent  }
     
 
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
